module.exports = __webpack_public_path__ + "static/media/boy-14.e1d548d0.svg";